"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _spinner = _interopRequireDefault(require("../spinner"));
var _index = _interopRequireDefault(require("./index"));
var _constants = _interopRequireDefault(require("./constants"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var CLASS_NAME = _styles.default['summary-status-wrapper'];

/**
 * Render survey list
 * @param  {Object} data
 * @return {Element} React element
 */
var SummaryStatusPillBox = function SummaryStatusPillBox(props) {
  var data = props.data,
    requesting = props.requesting,
    t = props.t;
  if (requesting) {
    return /*#__PURE__*/_react.default.createElement(_spinner.default, {
      show: true
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: CLASS_NAME
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pill-type"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, t ? t('Consent(s)') : 'Consent(s)'), /*#__PURE__*/_react.default.createElement(_index.default, {
    data: data,
    containerName: [_constants.default.CONTAINER_NAME.PRIMARY_CONSENT, _constants.default.CONTAINER_NAME.ADDITIONAL_CONSENT],
    t: t
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pill-type"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, t ? t('Protocol Activities') : 'Protocol Activities'), /*#__PURE__*/_react.default.createElement(_index.default, {
    data: data,
    containerName: _constants.default.CONTAINER_NAME.PROTOCOL_ACTIVITIES,
    t: t
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pill-type"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, t ? t('Surveys') : 'Surveys'), /*#__PURE__*/_react.default.createElement(_index.default, {
    data: data,
    containerName: _constants.default.CONTAINER_NAME.SURVEYS,
    t: t
  })));
};
SummaryStatusPillBox.propTypes = {
  data: _propTypes.default.shape({}).isRequired,
  requesting: _propTypes.default.bool,
  t: _propTypes.default.func
};
SummaryStatusPillBox.defaultProps = {
  requesting: false,
  t: function t(x) {
    return x;
  }
};
var _default = SummaryStatusPillBox;
exports.default = _default;